import MfaMethodSelector from './MfaMethodSelector';

export default MfaMethodSelector;